import { FC } from "react";
import { IMiniBoxElementProps } from "./types";

const MiniBoxElement: FC<IMiniBoxElementProps> = ({ children, selected }) => {
  return (
    <div
      className={`flex items-center justify-center min-h-8 border border-greyBorder dark:border-blueBorderDark ${
        selected
          ? "border-l-blueDark dark:border-l-blueBorderDark border-l-4 bg-blueHover dark:bg-blueHoverDark"
          : "bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark"
      } rounded-md transition-all duration-450 mr-1 min-w-14 cursor-pointer hover:bg-blueHover dark:hover:bg-blueHoverDark hover:shadow-md px-2`}
    >
      {children}
    </div>
  );
};

export default MiniBoxElement;
